export default {
  methods: {
    produceKey() {
      return Math.random().toString(36).substr(2, 9);
    },
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    },
  },
};
